import React from 'react';
import PropTypes from 'prop-types';
import RenderApps from './RenderApps';

function egnyteApps(props) {
    const apps = props.apps.filter((app) => app.featuredOrder === -1).filter((app) => app.type === 'egnyte_apps');

    return (
        apps.length > 0 && (
            <div name="egnyte-apps">
                <h4 className="appsListItems-title">Egnyte Apps</h4>
                <div className="appsListItemsWrapper">
                    <RenderApps apps={apps} />
                </div>
            </div>
        )
    );
}
egnyteApps.propTypes = {
    apps: PropTypes.array,
};
export default egnyteApps;
